import { Text } from "../../../../components/common/typography";
import { Badge } from "../../../../components/common/badge";
import { getDocumentDisplayName } from "../../../../utils/onboarding";
import type { UserDtoDocumentsInner } from "../../../../api/api";
import { IconCircleCheck } from "@tabler/icons-react";
interface UploadedDocumentItemProps {
    document: UserDtoDocumentsInner;
}
export function UploadedDocumentItem({ document }: UploadedDocumentItemProps) {
    return (<div className="flex items-center justify-between p-3 bg-uiSecondary rounded-lg">
      <div className="flex items-center gap-3">
        <IconCircleCheck size={20} style={{
            color: "#10B981"
        }}/>
        <Text variant="body" tone="dark">
          {document.type ? getDocumentDisplayName(document.type) : "Document"}
        </Text>
      </div>
      <Badge label="Uploaded" state="success"/>
    </div>);
}
